import { route as error } from './error'
import { route as home } from './home'
import { route as landing } from './landing'
import { route as newsletter } from './newsletter'

export default [
  home, landing, newsletter, error,
]
